(() => {
  const initArticle = () => {
    const article = document.querySelector('.jc-article');
    if (!article || article.dataset.jcEnhanced === 'true') return;

    const content = article.querySelector('.article-template__content');
    const tocMount = article.querySelector('[data-jc-toc]');
    if (!content || !tocMount) return;

    article.dataset.jcEnhanced = 'true';

    const tocHeading = Array.from(content.querySelectorAll('h2')).find(
      (heading) => heading.textContent.trim().toLowerCase() === 'inhalt'
    );

    let toc = tocHeading ? tocHeading.closest('div') : null;

    if (toc) {
      toc.classList.add('jc-article-toc');
      toc.removeAttribute('style');
      toc.querySelectorAll('[style]').forEach((element) => element.removeAttribute('style'));
      tocMount.appendChild(toc);
    } else {
      const headings = Array.from(content.querySelectorAll('h2[id]'));
      if (headings.length) {
        toc = document.createElement('nav');
        toc.className = 'jc-article-toc';
        toc.setAttribute('aria-label', 'Inhaltsverzeichnis');

        const title = document.createElement('h2');
        title.textContent = 'Inhalt';
        toc.appendChild(title);

        const list = document.createElement('div');
        headings.forEach((heading) => {
          const link = document.createElement('a');
          link.href = '#' + heading.id;
          link.textContent = heading.textContent.trim();
          list.appendChild(link);
        });
        toc.appendChild(list);
        tocMount.appendChild(toc);
      }
    }

    const tocLinks = toc ? Array.from(toc.querySelectorAll('a[href^="#"]')) : [];

    const shopButtonArrow = `
      <span class="svg-wrapper" aria-hidden="true">
        <svg xmlns="http://www.w3.org/2000/svg" width="7.912" height="13" viewBox="0 0 7.912 13" focusable="false" aria-hidden="true">
          <path d="M16.3,9.3a.993.993,0,1,1,1.4,1.4L12.807,15.6a1.093,1.093,0,0,1-.807.316,1.131,1.131,0,0,1-.807-.316L6.3,10.7a.975.975,0,0,1,0-1.4A.96.96,0,0,1,7,9a.889.889,0,0,1,.7.3c2.536,2.536,4.288,4.248,4.288,4.248C11.989,13.576,12.036,13.579,16.3,9.3Z" transform="translate(-8.5 18.5) rotate(-90)" fill="#121212" stroke="#efd9a8" stroke-width="1"></path>
        </svg>
      </span>`;

    const ctaLinks = Array.from(content.querySelectorAll('a[style*="border-radius"]'));
    ctaLinks.forEach((link) => {
      if (toc && toc.contains(link)) return;
      link.removeAttribute('style');
      link.classList.add('button', 'button--primary');

      if (!link.querySelector('.svg-wrapper')) {
        link.insertAdjacentHTML('beforeend', shopButtonArrow);
      }

      const parent = link.parentElement;
      if (parent) {
        parent.removeAttribute('style');
        parent.classList.add('jc-article-actions');
      }
    });

    if (!tocLinks.length) return;

    const sections = tocLinks
      .map((link) => {
        const id = decodeURIComponent(link.getAttribute('href').slice(1));
        const target = document.getElementById(id);
        return target ? { link, target } : null;
      })
      .filter(Boolean);

    if (!sections.length) return;

    let ticking = false;

    const updateActiveLink = () => {
      const offset = Math.min(220, window.innerHeight * 0.3);
      let current = sections[0];

      sections.forEach((section) => {
        if (section.target.getBoundingClientRect().top <= offset) current = section;
      });

      sections.forEach((section) => {
        const active = section === current;
        section.link.classList.toggle('is-active', active);
        if (active) {
          section.link.setAttribute('aria-current', 'location');
        } else {
          section.link.removeAttribute('aria-current');
        }
      });

      ticking = false;
    };

    const onScroll = () => {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(updateActiveLink);
    };

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    tocLinks.forEach((link) => link.addEventListener('click', () => window.setTimeout(updateActiveLink, 80)));
    updateActiveLink();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initArticle, { once: true });
  } else {
    initArticle();
  }
})();